import { AuthRoutes } from '@xarvio/frontend-core-router/lib/AuthRoutes';
import { crossFarmUuid } from '@xarvio/frontend-core-platform/lib/constants';

const UserSettingsRoutes = {
  USER_PROFILE: 'user-profile',
  FARMS: 'farms',
  COLLABORATION: 'collaboration',
  CONNECTIONS: 'connections',
  WEATHER_STATIONS: 'weather-stations',
  DATA_SOURCES: 'data-sources',
  WHATS_NEW: 'whats-new',
} as const;

export enum Page {
  LANDING = 'LANDING',
  PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  SMART_SPRAYER = 'SMART_SPRAYER',
  SMART_SPRAYER_NEW = 'SMART_SPRAYER_NEW',
  SMART_SPRAYER_LANDING = 'SMART_SPRAYER_LANDING',
  SMART_SPRAYER_REGISTRATION = 'SMART_SPRAYER_REGISTRATION',
  SMART_SPRAYER_USER_SETTINGS = 'SMART_SPRAYER_USER_SETTINGS',
  LOGIN = 'LOGIN',
  REGISTRATION = 'REGISTRATION',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  RESET_PASSWORD = 'RESET_PASSWORD',
  EMAIL_VERIFIED = 'EMAIL_VERIFIED',
  ACCEPT_TC = 'ACCEPT_TC',
  REDIRECT_XARVIO_CONNECT_ONBOARDING = 'REDIRECT_XARVIO_CONNECT_ONBOARDING',
  ORGANISATION_INVITATION = 'ORGANISATION_INVITATION',
  STATUS = 'STATUS',
  TASK = 'TASK',
  WEATHER = 'WEATHER',
  HISTORY = 'HISTORY',
  HISTORY_CS = 'HISTORY_CS',
  NEW_HISTORY_CROP_DETAILS = 'NEW_HISTORY_CROP_DETAILS',
  ANALYTICS = 'ANALYTICS',
  NEW_ANALYTICS = 'NEW_ANALYTICS',
  SHOP_PRODUCTS = 'SHOP_PRODUCTS',
  SHOP_PRODUCTS_PURCHASE = 'SHOP_PRODUCTS_PURCHASE',
  SHOP_PRODUCTS_ACTIVE_LICENSES = 'SHOP_PRODUCTS_ACTIVE_LICENSES',
  SHOP_PRODUCTS_ORDER_HISTORY = 'SHOP_PRODUCTS_ORDER_HISTORY',
  SHOP_PRODUCTS_SUBSCRIPTIONS = 'SHOP_PRODUCTS_SUBSCRIPTIONS',
  SHOP_ORDER = 'SHOP_ORDER',
  HEALTHY_FIELDS_OVERVIEW = 'HEALTHY_FIELDS_OVERVIEW',
  HEALTHY_FIELDS_SERVICES = 'HEALTHY_FIELDS_SERVICES',
  HEALTHY_FIELDS = 'HEALTHY_FIELDS',
  HEALTHY_FIELDS_CLAIMS = 'HEALTHY_FIELDS_CLAIMS',
  HEALTHY_FIELDS_REQUEST = 'HEALTHY_FIELDS_REQUEST',
  HEALTHY_FIELDS_CONTRACTOR_REQUEST = 'HEALTHY_FIELDS_CONTRACTOR_REQUEST',
  HEALTHY_FIELDS_OVERVIEW_NEW = 'HEALTHY_FIELDS_OVERVIEW_NEW',
  HEALTHY_FIELDS_SERVICES_NEW = 'HEALTHY_FIELDS_SERVICES_NEW',
  HEALTHY_FIELDS_REQUEST_NEW = 'HEALTHY_FIELDS_REQUEST_NEW',
  HEALTHY_FIELDS_CONTRACTOR_REQUEST_NEW = 'HEALTHY_FIELDS_CONTRACTOR_REQUEST_NEW',
  HEALTHY_FIELDS_OFFER_ACCEPT_OR_REJECT = 'HEALTHY_FIELDS_OFFER_ACCEPT_OR_REJECT',
  USER_PROFILE = 'USER_PROFILE',
  FARM_SETTINGS = 'FARM_SETTINGS',
  COLLABORATION_SETTINGS = 'COLLABORATION_SETTINGS',
  CONNECTED_APP_SETTINGS = 'CONNECTED_APP_SETTINGS',
  WEATHER_STATION_SETTINGS = 'WEATHER_STATION_SETTINGS',
  DATA_ATTRIBUTION_SETTINGS = 'DATA_ATTRIBUTION_SETTINGS',
  EXPERT_VIEW = 'EXPERT_VIEW',
  CROP_SEASON_ASSIGN = 'CROP_SEASON_ASSIGN',
  CROP_SEASON_EDIT = 'CROP_SEASON_EDIT',
  SEEDING_TASK_EDIT = 'SEEDING_TASK_EDIT',
  SEEDING_TASK_CREATION = 'SEEDING_TASK_CREATION',
  SCOUTING_TASK_EDIT = 'SCOUTING_TASK_EDIT',
  SCOUTING_TASK_CREATION = 'SCOUTING_TASK_CREATION',
  SCOUTING_TASK_EDIT_NEW = 'SCOUTING_TASK_EDIT_NEW',
  SCOUTING_TASK_CREATION_NEW = 'SCOUTING_TASK_CREATION_NEW',
  SEED_TREATMENT_TASK_EDIT = 'SEED_TREATMENT_TASK_EDIT',
  SEED_TREATMENT_TASK_CREATION = 'SEED_TREATMENT_TASK_CREATION',
  SEEDBOX_TREATMENT_TASK_EDIT = 'SEEDBOX_TREATMENT_TASK_EDIT',
  SEEDBOX_TREATMENT_TASK_CREATION = 'SEEDBOX_TREATMENT_TASK_CREATION',
  DRONE_FLIGHT_TASK_EDIT = 'DRONE_FLIGHT_TASK_EDIT',
  DRONE_FLIGHT_TASK_CREATION = 'DRONE_FLIGHT_TASK_CREATION',
  NUTRITION_TASK_EDIT = 'NUTRITION_TASK_EDIT',
  NUTRITION_TASK_CREATION = 'NUTRITION_TASK_CREATION',
  CROP_PROTECTION_TASK_EDIT = 'CROP_PROTECTION_TASK_EDIT',
  CROP_PROTECTION_TASK_CREATION = 'CROP_PROTECTION_TASK_CREATION',
  NUTRITION_TASK_EDIT_NEW = 'NUTRITION_TASK_EDIT_NEW',
  NUTRITION_TASK_CREATION_NEW = 'NUTRITION_TASK_CREATION_NEW',
  CROSS_FARM_DASHBOARD = 'CROSS_FARM_DASHBOARD',
  CROSS_FARM_DASHBOARD_GENERAL = 'CROSS_FARM_DASHBOARD_GENERAL',
  CROSS_FARM_DASHBOARD_RISKS = 'CROSS_FARM_DASHBOARD_RISKS',
  CROSS_FARM_DASHBOARD_TASKS = 'CROSS_FARM_DASHBOARD_TASKS',
  CROSS_FARM_DASHBOARD_SOIL = 'CROSS_FARM_DASHBOARD_SOIL',
  CROSS_FARM_DASHBOARD_CROP_DETAILS = 'CROSS_FARM_DASHBOARD_CROP_DETAILS',
  CROSS_FARM_DASHBOARD_FIELD_TRIALS = 'CROSS_FARM_DASHBOARD_FIELD_TRIALS',
  CROSS_FARM_DASHBOARD_SCOUTING = 'CROSS_FARM_DASHBOARD_SCOUTING',
  CROSS_FARM_DASHBOARD_PROTOCOLS = 'CROSS_FARM_DASHBOARD_PROTOCOLS',
  CROSS_FARM_DASHBOARD_TRIPS = 'CROSS_FARM_DASHBOARD_TRIPS',
  CROSS_FARM_DASHBOARD_HEALTHY_FIELDS_OVERVIEW = 'CROSS_FARM_DASHBOARD_HEALTHY_FIELDS_OVERVIEW',
  CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__COMMERCIAL_PARTNER = 'CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__COMMERCIAL_PARTNER',
  CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__SEASON_COORDINATOR = 'CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__SEASON_COORDINATOR',
  CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__AGRONOMIST = 'CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__AGRONOMIST',
  CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__CONTRACTOR = 'CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__CONTRACTOR',
  CROSS_FARM_DASHBOARD_FIELD_NOTES = 'CROSS_FARM_DASHBOARD_FIELD_NOTES',
  CROSS_FARM_DASHBOARD_SMART_SPRAYER = 'CROSS_FARM_DASHBOARD_SMART_SPRAYER',
  FDL_UPLOAD = 'FDL_UPLOAD',
  NOTES = 'NOTES',
  ADD_NOTE = 'ADD_NOTE',
  EDIT_NOTE = 'EDIT_NOTE',
  FIELD_DETECT = 'FIELD_DETECT',
  FIELD_UPLOAD = 'FIELD_UPLOAD',
  EDIT_FIELD = 'EDIT_FIELD',
  ONBOARDING_ADD_FIELD = 'ONBOARDING_ADD_FIELD',
  ONBOARDING_ADD_FIELD_HF = 'ONBOARDING_ADD_FIELD_HF',
  ONBOARDING_ASSIGN_CROPSEASON = 'ONBOARDING_ASSIGN_CROPSEASON',
  WATER_MANAGEMENT_TASK_EDIT = 'WATER_MANAGEMENT_TASK_EDIT',
  LAND_MANAGEMENT_TASK_EDIT = 'LAND_MANAGEMENT_TASK_EDIT',
  WATER_MANAGEMENT_TASK_CREATION = 'WATER_MANAGEMENT_TASK_CREATION',
  LAND_PREPARATION_CREATION = 'LAND_PREPARATION_CREATION',
  CROP_SEASON_TREATMENT_PROGRAMS = 'CROP_SEASON_TREATMENT_PROGRAMS',
  CROP_SEASON_TREATMENT_PROGRAM_CREATION = 'CROP_SEASON_TREATMENT_PROGRAM_CREATION',
  CROP_SEASON_TREATMENT_PROGRAM_RECOMMENDATIONS = 'CROP_SEASON_TREATMENT_PROGRAM_RECOMMENDATIONS',
  HARVEST_TASK_EDIT = 'HARVEST_TASK_EDIT',
  HARVEST_TASK_CREATION = 'HARVEST_TASK_CREATION',
  SMART_SPRAYING_TASK_CREATION = 'SMART_SPRAYING_TASK_CREATION',
  SMART_SPRAYING_TASK_EDIT = 'SMART_SPRAYING_TASK_EDIT',
  HERBICIDE_TASK_CREATION = 'HERBICIDE_TASK_CREATION',
  HERBICIDE_TASK_EDIT = 'HERBICIDE_TASK_EDIT',
  SUSTAINABILITY = 'SUSTAINABILITY',
  BIOENERGY = 'BIOENERGY',
  BIOENERGY_COMPANY = 'BIOENERGY_COMPANY',
  BIOENERGY_JOIN = 'BIOENERGY_JOIN',
  BIOENERGY_ENROLLMENT = 'BIOENERGY_ENROLLMENT',
  BIOENERGY_ENROLLMENT_DETAILS = 'BIOENERGY_ENROLLMENT_DETAILS',
  BIOENERGY_NEW_PROGRAM = 'BIOENERGY_NEW_PROGRAM',
  BIOENERGY_ENROLLMENT_SELECT_FIELDS = 'BIOENERGY_ENROLLMENT_SELECT_FIELDS',
  BIOENERGY_ENROLLMENT_CONFIRM = 'BIOENERGY_ENROLLMENT_CONFIRM',
  BIOENERGY_CFD = 'BIOENERGY_CFD',
  BIOENERGY_CFD_COMPANY = 'BIOENERGY_CFD_COMPANY',
  BIOENERGY_CFD_NEW_PROGRAM = 'BIOENERGY_CFD_NEW_PROGRAM',
  MANAGEMENT_ZONES = 'MANAGEMENT_ZONES',
  MANAGEMENT_ZONES_DRAW = 'MANAGEMENT_ZONES_DRAW',
  MANAGEMENT_AB_LINES = 'MANAGEMENT_AB_LINES',
  MANAGEMENT_AB_LINES_DRAW = 'MANAGEMENT_AB_LINES_DRAW',
  MANAGEMENT_FIELD_ENTRIES = 'MANAGEMENT_FIELD_ENTRIES',
  MANAGEMENT_FIELD_ENTRIES_DRAW = 'MANAGEMENT_FIELD_ENTRIES_DRAW',
  MANAGEMENT_GUIDANCE_PATTERN = 'MANAGEMENT_GUIDANCE_PATTERN',
  MANAGEMENT_GUIDANCE_PATTERN_DRAW = 'MANAGEMENT_GUIDANCE_PATTERN_DRAW',
  MANAGEMENT_ZONES_NEW = 'MANAGEMENT_ZONES_NEW',
  MAP_IMPORT = 'MAP_IMPORT',
  WHATS_NEW = 'WHATS_NEW',
  NUTRITION_PLANNING = 'NUTRITION_PLANNING',
  HEALTHY_FIELDS_COMMERCIAL_PARTNER_NEW = 'HEALTHY_FIELDS_COMMERCIAL_PARTNER_NEW',
  HEALTHY_FIELDS_SEASON_COORDINATOR_NEW = 'HEALTHY_FIELDS_SEASON_COORDINATOR_NEW',
  HEALTHY_FIELDS_AGRONOMIST_NEW = 'HEALTHY_FIELDS_AGRONOMIST_NEW',
  HEALTHY_FIELDS_CONTRACTOR_NEW = 'HEALTHY_FIELDS_CONTRACTOR_NEW',
  HEALTHY_FIELDS_FIELD_REGISTRATION = 'HEALTHY_FIELDS_FIELD_REGISTRATION',
  HEALTHY_FIELDS_FIELD_REGISTRATION_GREENLEAF_CZ = 'HEALTHY_FIELDS_FIELD_REGISTRATION_GREENLEAF_CZ',
  HEALTHY_FIELDS_FIELD_REGISTRATION_COTEGRA_CA = 'HEALTHY_FIELDS_FIELD_REGISTRATION_COTEGRA_CA',
  HEALTHY_FIELDS_FIELD_REGISTRATION_BRAZIL = 'HEALTHY_FIELDS_FIELD_REGISTRATION_BRAZIL',
  CONNECTED_OFFERS = 'CONNECTED_OFFERS',
  PLANTED_HECTARES_FIELD_REGISTRATION = 'PLANTED_HECTARES_FIELD_REGISTRATION',
  STATUS_NEW_ALL_FIELDS = 'STATUS_NEW_ALL_FIELDS',
  STATUS_NEW_RECOMMENDATIONS = 'STATUS_NEW_RECOMMENDATIONS',
  STATUS_NEW_UNASSIGNED_FIELDS = 'STATUS_NEW_UNASSIGNED_FIELDS',
  STATUS_NEW_CROP_OVERVIEW = 'STATUS_NEW_CROP_OVERVIEW',
  STATUS_NEW_CROP_FIELDS = 'STATUS_NEW_CROP_FIELDS',
  STATUS_NEW_CROP_NUTRITION = 'STATUS_NEW_CROP_NUTRITION',
  STATUS_NEW_CROP_WEED_MANAGEMENT = 'STATUS_NEW_CROP_WEED_MANAGEMENT',
  STATUS_NEW_FIELD_DETAILS = 'STATUS_NEW_FIELD_DETAILS',
  STATUS_TABLE_ALL_FIELDS_GENERAL = 'STATUS_TABLE_ALL_FIELDS_GENERAL',
  NUTRITION_PLANNING_PROGRAM_CREATION = 'NUTRITION_PLANNING_PROGRAM_CREATION',
  NUTRITION_PLANNING_N_PILOTING_CREATION = 'NUTRITION_PLANNING_N_PILOTING_CREATION',
  NUTRITION_PLANNING_MAP_CREATION = 'NUTRITION_PLANNING_MAP_CREATION',
  MULTI_SEASON_NUTRITION_PLANNING_PROGRAM_CREATION = 'MULTI_SEASON_NUTRITION_PLANNING_PROGRAM_CREATION',
  SEED_VARIETY_RECOMMENDATION = 'SEED_VARIETY_RECOMMENDATION',
  CARBON_FARMING = 'CARBON_FARMING',
  CARBON_FARMING_ENROLLMENT = 'CARBON_FARMING_ENROLLMENT',
  ADD_TEST_RESULT = 'ADD_TEST_RESULT',
  CARBON_FARMING_OVERVIEW = 'CARBON_FARMING_OVERVIEW',
  CARBON_FARMING_TIMELINE = 'CARBON_FARMING_TIMELINE',
  CARBON_FARMING_REPORTS = 'CARBON_FARMING_REPORTS',
  CARBON_FARMING_STATISTICS = 'CARBON_FARMING_STATISTICS',
  CARBON_FARMING_CFD = 'CARBON_FARMING_CFD',
  ADD_PROTOCOL = 'ADD_PROTOCOL',
  ADD_TRIAL = 'ADD_TRIAL',
  KUBOTA_FIELD_IMPORT = 'KUBOTA_FIELD_IMPORT',

  NOT_IMPLEMENTED_YET = 'NOT_IMPLEMENTED_YET',
  EXATREK_SETTINGS = 'EXATREK_SETTINGS',
  BUSINESS_LINES = 'BUSINESS_LINES',
  BUSINESS_LINES_LICENSES_OVERVIEW = 'BUSINESS_LINES_LICENSES_OVERVIEW',
  BUSINESS_LINES_LICENSES_REQUESTS = 'BUSINESS_LINES_LICENSES_REQUESTS',
  QUOTA_TRANSFER = 'QUOTA_TRANSFER',
  BUSINESS_LINES_OVERVIEW = 'BUSINESS_LINES_OVERVIEW',
  ORGANISATION_MEMBERS = 'ORGANISATION_MEMBERS',
  ORGANISATION_INVITATIONS = 'ORGANISATION_INVITATIONS',
  ORGANISATION_SETTINGS = 'ORGANISATION_SETTINGS',
  ORGANISATION_SETTINGS_VIEW = 'ORGANISATION_SETTINGS_VIEW',
  ORGANISATION_LOCATIONS = 'ORGANISATION_LOCATIONS',
  BUSINESS_LINES_FARMS = 'BUSINESS_LINES_FARMS',
  AGRONOMY_DASHBOARD = 'AGRONOMY_DASHBOARD',
  AGRONOMY_CARBON_FARMING = 'AGRONOMY_CARBON_FARMING',
  AGRONOMY_BARILLA = 'AGRONOMY_BARILLA',
  AGRONOMY_PERONI = 'AGRONOMY_PERONI',
  AGRONOMY_COTEGRA = 'AGRONOMY_COTEGRA',
  AGRONOMY_NEMAFREE = 'AGRONOMY_NEMAFREE',
  AGRONOMY_WEED_ZONE_SPRAY = 'AGRONOMY_WEED_ZONE_SPRAY',
  CALCULATE_NUTRITION_DEMAND = 'CALCULATE_NUTRITION_DEMAND',
  AUTO_LOGIN = 'AUTO_LOGIN',
  BARILLA_ONBOARDING = 'BARILLA_ONBOARDING',
  PERONI_ONBOARDING = 'PERONI_ONBOARDING',
  HORTA_GRAPE_ONBOARDING = 'HORTA_GRAPE_ONBOARDING',
  GRAPES_ONBOARDING_ADD_FIELDS = 'GRAPES_ONBOARDING_ADD_FIELDS',
  GRAPES_ONBOARDING_ASSIGN_CROP = 'GRAPES_ONBOARDING_ASSIGN_CROP',
  HORTA_NUTRITION_DEMAND = 'HORTA_NUTRITION_DEMAND',
  STATUS_NEW_ALL_FIELDS_NUTRITION = 'STATUS_NEW_ALL_FIELDS_NUTRITION',
  HORTA_NUTRITION_PLANNING_PROGRAM_CREATION = 'HORTA_NUTRITION_PLANNING_PROGRAM_CREATION',
}

interface GetPageUrlDicProps {
  prefix?: string;
  farmUuid?: string;
  fieldUuid?: string;
  cropSeasonUuid?: string;
  urlQueryParams?: string;
  forRouting?: boolean;
}

export const getPageUrlDic = ({
  prefix = '',
  farmUuid: farmUuidParent,
  fieldUuid: fieldUuidParent,
  cropSeasonUuid: cropSeasonUuidParent,
  urlQueryParams = '',
  forRouting,
}: GetPageUrlDicProps) => {
  const farmUuid = forRouting ? ':farmUuid' : farmUuidParent;
  const fieldUuid = forRouting ? ':fieldUuid' : fieldUuidParent;
  const cropSeasonUuid = forRouting ? ':cropSeasonUuid' : cropSeasonUuidParent;
  const pageDic: { [key in Page]: string } = {
    [Page.LANDING]: ``,
    [Page.LOGIN]: `/${AuthRoutes.LOGIN}`,
    [Page.REGISTRATION]: `/${AuthRoutes.REGISTRATION}`,
    [Page.FORGOT_PASSWORD]: `/${AuthRoutes.FORGOT_PASSWORD}`,
    [Page.RESET_PASSWORD]: `/${AuthRoutes.RESET_PASSWORD}`,
    [Page.EMAIL_VERIFIED]: `/${AuthRoutes.EMAIL_VERIFIED}`,
    [Page.ACCEPT_TC]: `/${AuthRoutes.ACCEPT_TC}`,
    [Page.AUTO_LOGIN]: `/${AuthRoutes.AUTO_LOGIN}`,
    [Page.USER_PROFILE]: `/farm/${farmUuid}/settings/${UserSettingsRoutes.USER_PROFILE}`,
    [Page.FARM_SETTINGS]: `/farm/${farmUuid}/settings/${UserSettingsRoutes.FARMS}`,
    [Page.COLLABORATION_SETTINGS]: `/farm/${farmUuid}/settings/${UserSettingsRoutes.COLLABORATION}`,
    [Page.CONNECTED_APP_SETTINGS]: `/farm/${farmUuid}/settings/${UserSettingsRoutes.CONNECTIONS}`,
    [Page.WEATHER_STATION_SETTINGS]: `/farm/${farmUuid}/settings/${UserSettingsRoutes.WEATHER_STATIONS}`,
    [Page.DATA_ATTRIBUTION_SETTINGS]: `/farm/${farmUuid}/settings/${UserSettingsRoutes.DATA_SOURCES}`,
    [Page.WHATS_NEW]: `/farm/${farmUuid}/settings/${UserSettingsRoutes.WHATS_NEW}`,
    [Page.PAYMENT_SUCCESS]: `/payment/success`,
    [Page.PAYMENT_FAILED]: `/payment/failed`,
    [Page.SMART_SPRAYER_LANDING]: `/${AuthRoutes.SMART_SPRAYER_LANDING}`,
    [Page.SMART_SPRAYER_REGISTRATION]: `/${AuthRoutes.SMART_SPRAYER_REGISTRATION}`,
    [Page.SMART_SPRAYER_USER_SETTINGS]: `/farm/${farmUuid}/settings/smart-sprayer`,
    [Page.REDIRECT_XARVIO_CONNECT_ONBOARDING]: '/xconnect',
    [Page.ORGANISATION_INVITATION]: '/organisation-invitation',
    [Page.EXATREK_SETTINGS]: `/farm/${farmUuid}/settings/exatrek`,
    [Page.BUSINESS_LINES]: `/farm/dashboard/business-lines`,
    [Page.BUSINESS_LINES_OVERVIEW]: `/farm/dashboard/business-lines/overview`,
    [Page.BUSINESS_LINES_LICENSES_OVERVIEW]: `/farm/dashboard/business-lines/licenses-overview`,
    [Page.BUSINESS_LINES_LICENSES_REQUESTS]: `/farm/dashboard/business-lines/licenses-requests`,
    [Page.QUOTA_TRANSFER]: `/farm/dashboard/business-lines/quota-transfer`,
    [Page.ORGANISATION_MEMBERS]: `/farm/dashboard/organisation/members`,
    [Page.ORGANISATION_INVITATIONS]: `/farm/dashboard/organisation/invitations`,
    [Page.ORGANISATION_SETTINGS]: `/farm/dashboard/organisation/settings`,
    [Page.ORGANISATION_SETTINGS_VIEW]: `/farm/dashboard/organisation/settings-view`,
    [Page.ORGANISATION_LOCATIONS]: `/farm/dashboard/organisation/locations`,
    [Page.BUSINESS_LINES_FARMS]: `/farm/dashboard/business-lines/farms`,
    [Page.STATUS]: `/farm/${farmUuid}/field/status`,
    [Page.TASK]: `/farm/${farmUuid}/task`,
    [Page.SMART_SPRAYER]: `/farm/${farmUuid}/smart-sprayer`,
    [Page.SMART_SPRAYER_NEW]: `/farm/${farmUuid}/new-smart-sprayer`,
    [Page.WEATHER]: `/farm/${farmUuid}/field/weather`,
    [Page.HISTORY]: `/farm/${farmUuid}/fields`,
    [Page.HISTORY_CS]: `/farm/${farmUuid}/fields/${fieldUuid}/${cropSeasonUuid}`,
    [Page.NEW_HISTORY_CROP_DETAILS]: `/farm/${farmUuid}/timeline/details`,
    [Page.ANALYTICS]: `/farm/${farmUuid}/fdl`,
    [Page.NEW_ANALYTICS]: `/farm/${farmUuid}/new-fdl`,
    [Page.SHOP_PRODUCTS]: `/farm/${farmUuid}/shop/products`,
    [Page.SHOP_PRODUCTS_PURCHASE]: `/farm/${farmUuid}/shop/products/purchase`,
    [Page.SHOP_PRODUCTS_ACTIVE_LICENSES]: `/farm/${farmUuid}/shop/products/active-licenses`,
    [Page.SHOP_PRODUCTS_ORDER_HISTORY]: `/farm/${farmUuid}/shop/products/order-history`,
    [Page.SHOP_PRODUCTS_SUBSCRIPTIONS]: `/farm/${farmUuid}/shop/products/subscriptions`,
    [Page.SHOP_ORDER]: `/farm/${farmUuid}/shop/order`,
    [Page.HEALTHY_FIELDS_OVERVIEW]: `/farm/${farmUuid}/healthy-fields/overview`,
    [Page.HEALTHY_FIELDS_SERVICES]: `/farm/${farmUuid}/healthy-fields/services`,
    [Page.HEALTHY_FIELDS]: `/farm/${farmUuid}/healthy-fields/dashboard`,
    [Page.HEALTHY_FIELDS_CLAIMS]: `/farm/${farmUuid}/healthy-fields/claims`,
    [Page.HEALTHY_FIELDS_REQUEST]: `/farm/${farmUuid}/healthy-fields/request`,
    [Page.HEALTHY_FIELDS_CONTRACTOR_REQUEST]: `/farm/${farmUuid}/healthy-fields/contractor-request`,
    [Page.EXPERT_VIEW]: `/farm/${farmUuid}/expert/${fieldUuid}`,
    [Page.CROP_SEASON_EDIT]: `/farm/${farmUuid}/crop-season/edit`,
    [Page.CROP_SEASON_ASSIGN]: `/farm/${farmUuid}/crop-season/assign`,
    [Page.SEEDING_TASK_EDIT]: `/farm/${farmUuid}/task/edit/seeding`,
    [Page.SEEDING_TASK_CREATION]: `/farm/${farmUuid}/task/add/seeding`,
    [Page.SCOUTING_TASK_EDIT]: `/farm/${farmUuid}/task/edit/scouting`,
    [Page.SCOUTING_TASK_CREATION]: `/farm/${farmUuid}/task/add/scouting`,
    [Page.SEED_TREATMENT_TASK_EDIT]: `/farm/${farmUuid}/task/edit/seed-treatment`,
    [Page.SEED_TREATMENT_TASK_CREATION]: `/farm/${farmUuid}/task/add/seed-treatment`,
    [Page.SEEDBOX_TREATMENT_TASK_CREATION]: `/farm/${farmUuid}/task/add/seedbox-treatment`,
    [Page.SEEDBOX_TREATMENT_TASK_EDIT]: `/farm/${farmUuid}/task/edit/seedbox-treatment`,
    [Page.CROSS_FARM_DASHBOARD]: `/farm/${crossFarmUuid}/home`,
    [Page.CROSS_FARM_DASHBOARD_GENERAL]: `/farm/${crossFarmUuid}/general`,
    [Page.CROSS_FARM_DASHBOARD_RISKS]: `/farm/${crossFarmUuid}/risks`,
    [Page.CROSS_FARM_DASHBOARD_TASKS]: `/farm/${crossFarmUuid}/tasks`,
    [Page.CROSS_FARM_DASHBOARD_SOIL]: `/farm/${crossFarmUuid}/soil`,
    [Page.CROSS_FARM_DASHBOARD_CROP_DETAILS]: `/farm/${crossFarmUuid}/crop-details`,
    [Page.CROSS_FARM_DASHBOARD_FIELD_TRIALS]: `/farm/${crossFarmUuid}/field-trials`,
    [Page.CROSS_FARM_DASHBOARD_SCOUTING]: `/farm/${crossFarmUuid}/scouting`,
    [Page.CROSS_FARM_DASHBOARD_PROTOCOLS]: `/farm/${crossFarmUuid}/scouting/protocols`,
    [Page.CROSS_FARM_DASHBOARD_TRIPS]: `/farm/${crossFarmUuid}/scouting/trips`,
    [Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS_OVERVIEW]: `/farm/${crossFarmUuid}/healthy-fields/overview`,
    [Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__COMMERCIAL_PARTNER]: `/farm/${crossFarmUuid}/healthy-fields/commercial`,
    [Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__SEASON_COORDINATOR]: `/farm/${crossFarmUuid}/healthy-fields/coordinator`,
    [Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__AGRONOMIST]: `/farm/${crossFarmUuid}/healthy-fields/agronomist`,
    [Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__CONTRACTOR]: `/farm/${crossFarmUuid}/healthy-fields/contractor`,
    [Page.CROSS_FARM_DASHBOARD_FIELD_NOTES]: `/farm/${crossFarmUuid}/field-notes`,
    [Page.CROSS_FARM_DASHBOARD_SMART_SPRAYER]: `/farm/${crossFarmUuid}/smart-sprayer`,
    [Page.AGRONOMY_DASHBOARD]: `/farm/${crossFarmUuid}/agronomy/dashboard`,
    [Page.AGRONOMY_CARBON_FARMING]: `/farm/${crossFarmUuid}/agronomy/carbon-farming`,
    [Page.AGRONOMY_BARILLA]: `/farm/${crossFarmUuid}/carbon-farming/barilla`,
    [Page.AGRONOMY_PERONI]: `/farm/${crossFarmUuid}/carbon-farming/peroni`,
    [Page.AGRONOMY_COTEGRA]: `/farm/${crossFarmUuid}/agronomy/cotegra`,
    [Page.AGRONOMY_NEMAFREE]: `/farm/${crossFarmUuid}/agronomy/nemafree`,
    [Page.AGRONOMY_WEED_ZONE_SPRAY]: `/farm/${crossFarmUuid}/agronomy/weed-zone-spray`,
    [Page.FDL_UPLOAD]: `/farm/${farmUuid}/fdl-upload`,
    [Page.NOTES]: `/farm/${farmUuid}/notes`,
    [Page.ADD_NOTE]: `/farm/${farmUuid}/notes/add`,
    [Page.EDIT_NOTE]: `/farm/${farmUuid}/notes/${fieldUuid}/edit`,
    [Page.FIELD_DETECT]: `/farm/${farmUuid}/field/detect`,
    [Page.FIELD_UPLOAD]: `/farm/${farmUuid}/field/upload`,
    [Page.EDIT_FIELD]: `/farm/${farmUuid}/field/edit/${fieldUuid}`,
    [Page.ONBOARDING_ADD_FIELD]: `/farm/${farmUuid}/onboarding/add-field`,
    [Page.ONBOARDING_ADD_FIELD_HF]: `/farm/${farmUuid}/onboarding/add-field-hf`,
    [Page.ONBOARDING_ASSIGN_CROPSEASON]: `/farm/${farmUuid}/onboarding/assign-cropseason`,
    [Page.WATER_MANAGEMENT_TASK_EDIT]: `/farm/${farmUuid}/task/edit/water-management`,
    [Page.LAND_MANAGEMENT_TASK_EDIT]: `/farm/${farmUuid}/task/edit/land-preparation`,
    [Page.WATER_MANAGEMENT_TASK_CREATION]: `/farm/${farmUuid}/task/add/water-management`,
    [Page.CROP_SEASON_TREATMENT_PROGRAMS]: `/farm/${farmUuid}/cropseason-treatment-programs`,
    [Page.CROP_SEASON_TREATMENT_PROGRAM_CREATION]: `/farm/${farmUuid}/cropseason-treatment-program-creation`,
    [Page.LAND_PREPARATION_CREATION]: `/farm/${farmUuid}/task/add/land-preparation`,
    [Page.CROP_SEASON_TREATMENT_PROGRAM_RECOMMENDATIONS]: `/farm/${farmUuid}/cropseason-treatment-program-recommendations`,
    [Page.HARVEST_TASK_EDIT]: `/farm/${farmUuid}/task/edit/harvest-task`,
    [Page.HARVEST_TASK_CREATION]: `/farm/${farmUuid}/task/add/harvest-task`,
    [Page.SMART_SPRAYING_TASK_CREATION]: `/farm/${farmUuid}/task/add/smart-spraying-task`,
    [Page.SMART_SPRAYING_TASK_EDIT]: `/farm/${farmUuid}/task/edit/smart-spraying-task`,
    [Page.HERBICIDE_TASK_CREATION]: `/farm/${farmUuid}/task/add/new-herbicide`,
    [Page.HERBICIDE_TASK_EDIT]: `/farm/${farmUuid}/task/edit/new-herbicide`,
    [Page.SUSTAINABILITY]: `/farm/${farmUuid}/sustainability`,
    [Page.BIOENERGY]: `/farm/${farmUuid}/bioenergy`,
    [Page.BIOENERGY_COMPANY]: `/farm/${farmUuid}/bioenergy/company`,
    [Page.BIOENERGY_JOIN]: `/farm/${farmUuid}/bioenergy/grower/join`,
    [Page.BIOENERGY_ENROLLMENT]: `/farm/${farmUuid}/bioenergy/grower/enrollment`,
    [Page.BIOENERGY_ENROLLMENT_DETAILS]: `/farm/${farmUuid}/bioenergy/grower/enrollment/details`,
    [Page.BIOENERGY_NEW_PROGRAM]: `/farm/${farmUuid}/bioenergy/company/new-program`,
    [Page.BIOENERGY_ENROLLMENT_SELECT_FIELDS]: `/farm/${farmUuid}/bioenergy/grower/enrollment/select-fields`,
    [Page.BIOENERGY_ENROLLMENT_CONFIRM]: `/farm/${farmUuid}/bioenergy/grower/enrollment/confirm`,
    [Page.BIOENERGY_CFD]: `/farm/${crossFarmUuid}/bioenergy`,
    [Page.BIOENERGY_CFD_COMPANY]: `/farm/${crossFarmUuid}/bioenergy/company`,
    [Page.BIOENERGY_CFD_NEW_PROGRAM]: `/farm/${crossFarmUuid}/bioenergy/company/new-program`,
    [Page.MANAGEMENT_ZONES]: `/farm/${farmUuid}/field/management-zones`,
    [Page.MANAGEMENT_ZONES_DRAW]: `/farm/${farmUuid}/field/management-zones/draw`,
    [Page.MANAGEMENT_AB_LINES]: `/farm/${farmUuid}/field/reference-lines`,
    [Page.MANAGEMENT_AB_LINES_DRAW]: `/farm/${farmUuid}/field/reference-lines/draw-ab-line`,
    [Page.MANAGEMENT_FIELD_ENTRIES]: `/farm/${farmUuid}/field/field-entries/add`,
    [Page.MANAGEMENT_FIELD_ENTRIES_DRAW]: `/farm/${farmUuid}/field/field-entries`,
    [Page.MANAGEMENT_GUIDANCE_PATTERN]: `/farm/${farmUuid}/field/reference-lines`,
    [Page.MANAGEMENT_GUIDANCE_PATTERN_DRAW]: `/farm/${farmUuid}/field/reference-lines/draw-tramline`,
    [Page.MANAGEMENT_ZONES_NEW]: `/farm/${farmUuid}/field/management-zones-new`,
    [Page.DRONE_FLIGHT_TASK_CREATION]: `/farm/${farmUuid}/task/add/drone`,
    [Page.DRONE_FLIGHT_TASK_EDIT]: `/farm/${farmUuid}/task/edit/drone`,
    [Page.NUTRITION_TASK_CREATION]: `/farm/${farmUuid}/task/add/nutrition`,
    [Page.NUTRITION_TASK_EDIT]: `/farm/${farmUuid}/task/edit/nutrition`,
    [Page.CROP_PROTECTION_TASK_CREATION]: `/farm/${farmUuid}/task/add/crop-protection`,
    [Page.CROP_PROTECTION_TASK_EDIT]: `/farm/${farmUuid}/task/edit/crop-protection`,
    [Page.NUTRITION_TASK_CREATION_NEW]: `/farm/${farmUuid}/task/add/nutrition-new`,
    [Page.NUTRITION_TASK_EDIT_NEW]: `/farm/${farmUuid}/task/edit/nutrition-new`,
    [Page.SCOUTING_TASK_CREATION_NEW]: `/farm/${farmUuid}/task/add/scouting-new`,
    [Page.SCOUTING_TASK_EDIT_NEW]: `/farm/${farmUuid}/task/edit/scouting-new`,
    [Page.HEALTHY_FIELDS_OVERVIEW_NEW]: `/farm/${farmUuid}/healthy-fields/new-overview`,
    [Page.HEALTHY_FIELDS_SERVICES_NEW]: `/farm/${farmUuid}/healthy-fields/new-services`,
    [Page.HEALTHY_FIELDS_REQUEST_NEW]: `/farm/${farmUuid}/healthy-fields/new-request`,
    [Page.HEALTHY_FIELDS_CONTRACTOR_REQUEST_NEW]: `/farm/${farmUuid}/healthy-fields/new-contractor-request`,
    [Page.HEALTHY_FIELDS_OFFER_ACCEPT_OR_REJECT]: `/xhf-offer/:xHfOfferUuid/:xHfOfferStatus`,
    [Page.MAP_IMPORT]: `/map-import`,
    [Page.NUTRITION_PLANNING]: `/farm/${farmUuid}/nutrition-planning`,
    [Page.HEALTHY_FIELDS_COMMERCIAL_PARTNER_NEW]: `/farm/${farmUuid}/settings/healthy-fields/commercial`,
    [Page.HEALTHY_FIELDS_SEASON_COORDINATOR_NEW]: `/farm/${farmUuid}/settings/healthy-fields/coordinator`,
    [Page.HEALTHY_FIELDS_AGRONOMIST_NEW]: `/farm/${farmUuid}/settings/healthy-fields/agronomist`,
    [Page.HEALTHY_FIELDS_CONTRACTOR_NEW]: `/farm/${farmUuid}/settings/healthy-fields/contractor`,
    [Page.HEALTHY_FIELDS_FIELD_REGISTRATION]: `/farm/${farmUuid}/healthy-fields/register-fields`,
    [Page.HEALTHY_FIELDS_FIELD_REGISTRATION_GREENLEAF_CZ]: `/farm/${farmUuid}/healthy-fields/register-fields-greenleaf-cz`,
    [Page.HEALTHY_FIELDS_FIELD_REGISTRATION_COTEGRA_CA]: `/farm/${farmUuid}/healthy-fields/register-fields-cotegra-ca`,
    [Page.HEALTHY_FIELDS_FIELD_REGISTRATION_BRAZIL]: `/farm/${farmUuid}/healthy-fields/register-fields-brazil`,
    [Page.CONNECTED_OFFERS]: `/farm/${farmUuid}/connected-offers`,
    [Page.PLANTED_HECTARES_FIELD_REGISTRATION]: `/farm/${farmUuid}/healthy-fields/register-planted-hectares`,
    [Page.STATUS_NEW_ALL_FIELDS]: `/farm/${farmUuid}/field/status/all-fields`,
    [Page.STATUS_NEW_RECOMMENDATIONS]: `/farm/${farmUuid}/field/status/recommendations`,
    [Page.STATUS_NEW_UNASSIGNED_FIELDS]: `/farm/${farmUuid}/field/status/unassigned`,
    [Page.STATUS_NEW_CROP_OVERVIEW]: `/farm/${farmUuid}/field/status/overview`,
    [Page.STATUS_NEW_CROP_FIELDS]: `/farm/${farmUuid}/field/status/fields`,
    [Page.STATUS_NEW_CROP_NUTRITION]: `/farm/${farmUuid}/field/status/nutrition`,
    [Page.STATUS_NEW_CROP_WEED_MANAGEMENT]: `/farm/${farmUuid}/field/status/weed-management`,
    [Page.STATUS_NEW_FIELD_DETAILS]: `/farm/${farmUuid}/field/status/field-details`,
    [Page.STATUS_TABLE_ALL_FIELDS_GENERAL]: `/farm/${farmUuid}/field/status/all-fields/general`,
    [Page.NUTRITION_PLANNING_PROGRAM_CREATION]: `/farm/${farmUuid}/field/nutrition-planning-program-creation`,
    [Page.NUTRITION_PLANNING_N_PILOTING_CREATION]: `/farm/${farmUuid}/field/nutrition-planning-n-piloting-creation`,
    [Page.NUTRITION_PLANNING_MAP_CREATION]: `/farm/${farmUuid}/field/nutrition-planning-map-creation`,
    [Page.MULTI_SEASON_NUTRITION_PLANNING_PROGRAM_CREATION]: `/farm/${farmUuid}/field/multi-season-nutrition-planning-program-creation`,
    [Page.SEED_VARIETY_RECOMMENDATION]: `/farm/${farmUuid}/seed-variety-recommendations`,
    [Page.CARBON_FARMING]: `/farm/${farmUuid}/carbon-farming`,
    [Page.CARBON_FARMING_ENROLLMENT]: `/farm/${farmUuid}/carbon-farming/enrollment`,
    [Page.ADD_TEST_RESULT]: `/farm/${farmUuid}/field/add-test-result`,
    [Page.CARBON_FARMING_OVERVIEW]: `/farm/${farmUuid}/carbon-farming/overview`,
    [Page.CARBON_FARMING_TIMELINE]: `/farm/${farmUuid}/carbon-farming/timeline`,
    [Page.CARBON_FARMING_REPORTS]: `/farm/${farmUuid}/carbon-farming/reports`,
    [Page.CARBON_FARMING_STATISTICS]: `/farm/${farmUuid}/carbon-farming/statistics`,
    [Page.CARBON_FARMING_CFD]: `/farm/${crossFarmUuid}/sustainability`,
    [Page.ADD_PROTOCOL]: `/field-trials/add-protocol`,
    [Page.ADD_TRIAL]: `/field-trials/add-trial`,
    [Page.KUBOTA_FIELD_IMPORT]: `/farm/${farmUuid}/kubota/import-fields`,

    [Page.CALCULATE_NUTRITION_DEMAND]: `/farm/${farmUuid}/field/calculate-nutrition-demand`,
    [Page.BARILLA_ONBOARDING]: `/barilla-onboarding`,
    [Page.PERONI_ONBOARDING]: `/peroni-onboarding`,
    [Page.HORTA_GRAPE_ONBOARDING]: `/farm/${farmUuid}/horta-grape-onboarding`,
    [Page.GRAPES_ONBOARDING_ADD_FIELDS]: `/farm/${farmUuid}/onboarding-grapes/add-fields`,
    [Page.GRAPES_ONBOARDING_ASSIGN_CROP]: `/farm/${farmUuid}/onboarding-grapes/assign-crop`,
    [Page.HORTA_NUTRITION_DEMAND]: `/farm/${farmUuid}/horta-nutrition-demand`,
    [Page.STATUS_NEW_ALL_FIELDS_NUTRITION]: `/farm/${farmUuid}/field/status/all-fields/nutrition`,
    [Page.HORTA_NUTRITION_PLANNING_PROGRAM_CREATION]: `/farm/${farmUuid}/field/horta-nutrition-planning-program-creation`,
    [Page.NOT_IMPLEMENTED_YET]: ``,
  };

  for (const key in Page) {
    if (pageDic[key as keyof typeof Page]) {
      pageDic[key as keyof typeof Page] = forRouting
        ? pageDic[key as keyof typeof Page].slice(1)
        : prefix + pageDic[key as keyof typeof Page] + urlQueryParams;
    }
  }

  return pageDic;
};

const reversePageRoute = new Map<Page, string>();
for (const key in Page) {
  const val = Page[key as keyof typeof Page];
  reversePageRoute.set(val, key);
}
